export default{
    CREATE_AUTHOR(state, payload){
        state.elearnarticle = payload;
    },
    GET_AUTHOR_DATA(state, payload){
        state.elearnarticleData = payload;
    },
    GET_AUTHOR_DATA_LIST(state, payload){
        state.authorList = payload;
    },
}